import React from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";

function BarChart({ filterData,filterInCartD }) {
  // const MediaCategory = filterData.map((el) => el.media_type);
  // let medias;

  // medias = [...new Set(MediaCategory)];

  const traditional = filterData.filter(
    (el) =>
      el.media_type === "traditional-ooh-media" ||
      el.media_type === '"traditional-ooh-media"'
  );

  const transit = filterData.filter(
    (el) =>
      el.media_type === '"transit-media"' || el.media_type === "transit-media"
  );

  const mall = filterData.filter(
    (el) => el.media_type === "mall-media" || el.media_type === '"mall-media"'
  );
  const airport = filterData.filter(
    (el) =>
      el.media_type === "airport-media" || el.media_type === '"airport-media"'
  );
  const digital = filterData.filter(
    (el) =>
      el.media_type == "digital-media" || el.media_type === '"digital-media"'
  );

  const traditionalInCart = filterInCartD.filter(
    (el) =>
      el.mediatype === "traditional-ooh-media" ||
      el.mediatype === '"traditional-ooh-media"'
  );

  const transitInCart = filterInCartD.filter(
    (el) =>
      el.mediatype === '"transit-media"' || el.mediatype=== "transit-media"
  );

  const mallInCart = filterInCartD.filter(
    (el) => el.mediatype === "mall-media" || el.mediatype === '"mall-media"'
  );
  const airportInCart = filterInCartD.filter(
    (el) =>
      el.mediatype === "airport-media" || el.mediatype === '"airport-media"'
  );
  const digitalInCart = filterInCartD.filter(
    (el) =>
      el.mediatype == "digital-media" || el.mediatype === '"digital-media"'
  );

  const Category = {
    labels: [
      "Traditional-ooh-Media",
      "Transit-Media",
      "Mall-Media",
      "Airport-Media",
      "Digital",
    ],

    datasets: [
      
      {
        label: "In-Cart",
        fill: true,
        
        color: "red",
        borderWidth: 2,
        pointRadius: 2,
        data: [
          traditionalInCart.length,
          transitInCart.length,
          mallInCart.length,
          airportInCart.length,
          digitalInCart.length,
        ],
      },{
        label: "Orderd",
        fill: false,
        color: "blue",
        borderWidth: 2,
        pointRadius: 2,
        data: [
          traditional.length,
          transit.length,
          mall.length,
          airport.length,
          digital.length,
        ],
      }
      
    ],
  };

  return (
    <div className="app-main">
      <Bar data={Category} />
    </div>
  );
}

export default BarChart;
